// Display labels for alarm log entries, shared by the Timeline and the row
// history panel.

// "sent" is decided before sending and never updated, so it does not confirm delivery
export const notifyLabels = { sent: "Send attempted", muted: "After quiet hours", none: "Not set up" };

export function timeLabel(t) {
  const dt = new Date(t);
  return isNaN(dt)
    ? ""
    : `${dt.toLocaleDateString("en-GB")} ${dt.toLocaleTimeString("en-GB")}`;
}

// Zone alarms carry the zone in the type: geoFenceEntryAlarm_<zone> or
// geoFenceExitAlarm_<zone>. Rule alarms carry the rule name.
export function ruleLabel(type) {
  const text = type || "";
  if (text.startsWith("geoFenceEntryAlarm_"))
    return `Zone entry: ${text.slice("geoFenceEntryAlarm_".length)}`;
  if (text.startsWith("geoFenceExitAlarm_"))
    return `Zone exit: ${text.slice("geoFenceExitAlarm_".length)}`;
  return text;
}

export function valueLabel({ value, threshold }) {
  if (value === undefined || value === null || typeof value === "object")
    return "";
  return threshold === undefined || threshold === null
    ? `${value}`
    : `${value} (threshold ${threshold})`;
}

// "2 h 05 min", "45 min", "under 1 min".
export function durationLabel(ms) {
  const minutes = Math.round(ms / 60000);
  if (minutes < 1) return "under 1 min";
  const hours = Math.floor(minutes / 60);
  return hours
    ? `${hours} h ${String(minutes % 60).padStart(2, "0")} min`
    : `${minutes} min`;
}

export function problemLabel(entry) {
  if (entry.endAt) {
    const ms =
      typeof entry.durationMs === "number"
        ? entry.durationMs
        : new Date(entry.endAt) - new Date(entry.t);
    return `Ended after ${durationLabel(ms)}`;
  }
  return entry.kind === "event" ? "Event" : "Ongoing";
}
